import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";

const formatCurrency = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return "Não informado";
  return parsed.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
};

export default function FractionalFreightWarningModal({
  open,
  advertisedValue,
  minimumAntt,
  onClose,
  onContinue,
  loading = false,
}) {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      fullWidth
      maxWidth="sm"
      aria-labelledby="fractional-freight-warning-title"
      PaperProps={{ sx: { borderRadius: 3, p: 1.5 } }}
    >
      <DialogTitle
        id="fractional-freight-warning-title"
        sx={{ alignItems: "center", color: "#012443", display: "flex", fontWeight: 700, gap: 1.5, pr: 5 }}
      >
        <Box sx={{ alignItems: "center", backgroundColor: "#E8F3FF", borderRadius: "50%", display: "flex", height: 48, justifyContent: "center", width: 48 }}>
          <InfoIcon sx={{ color: "#0877D1", fontSize: 32 }} />
        </Box>
        Frete fracionado
      </DialogTitle>

      <IconButton aria-label="Fechar aviso de frete fracionado" disabled={loading} onClick={onClose} sx={{ position: "absolute", right: 12, top: 12 }}>
        <CloseIcon />
      </IconButton>

      <DialogContent>
        <Typography sx={{ color: "#425466", lineHeight: 1.45, mb: 2.5 }}>
          Este frete poderá ser anunciado abaixo do piso ANTT e será identificado como fracionado na plataforma.
        </Typography>

        <Box sx={{ backgroundColor: "#EAF4FF", borderRadius: 2, display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, p: 2.25 }}>
          <Box>
            <Typography sx={{ color: "#1765A8", fontSize: 14 }}>Valor anunciado</Typography>
            <Typography sx={{ color: "#012443", fontSize: 22, fontWeight: 700 }}>{formatCurrency(advertisedValue)}</Typography>
          </Box>
          <Box sx={{ borderLeft: { sm: "1px solid #BEDBFA" }, pl: { sm: 2 } }}>
            <Typography sx={{ color: "#1765A8", fontSize: 14 }}>Mínimo ANTT (referência)</Typography>
            <Typography sx={{ color: "#012443", fontSize: 22, fontWeight: 700 }}>{formatCurrency(minimumAntt)}</Typography>
          </Box>
        </Box>

        <Box sx={{ alignItems: "center", color: "#0877D1", display: "flex", gap: 1, mt: 2 }}>
          <InfoIcon fontSize="small" />
          <Typography sx={{ fontSize: 14 }}><strong>Frete fracionado:</strong> exceção à regra do piso mínimo da ANTT.</Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ gap: 1.5, px: 3, pb: 2 }}>
        <Button fullWidth variant="outlined" disabled={loading} onClick={onClose} sx={{ borderColor: "#D6DEE7", color: "#012443", py: 1.25, textTransform: "none" }}>Voltar</Button>
        <Button fullWidth variant="contained" disabled={loading} onClick={onContinue} sx={{ backgroundColor: "#012443", py: 1.25, textTransform: "none", "&:hover": { backgroundColor: "#013661" } }}>Continuar</Button>
      </DialogActions>
    </Dialog>
  );
}
